<template lang="pug">
    .box
        canvas.canvas(ref="canvas")
</template>

<script>
import storeMixin from '../store/mixin';
import qrcode from 'qrcode';

export default {
    name: 'Wepay',
    mixins: [storeMixin],
    props: {
        orderId: Number,
        payUrl: String,
    },
    data() {
        return {};
    },
    created() {},

    mounted() {
        qrcode.toCanvas(this.$refs.canvas, this.payUrl, error => {
            if (error) console.error(error);
            console.log('success!');
            this.checkOrder();
        });
    },
    watch: {
        payUrl() {
            this.clearTimer();

            qrcode.toCanvas(this.$refs.canvas, this.payUrl, error => {
                if (error) console.error(error);
                console.log('success!');
                this.checkOrder();
            });
        },
    },
    destroyed() {
        this.clearTimer();
    },
    methods: {
        clearTimer() {
            try {
                clearTimeout(this.$data._timer);
            } catch (e) {
                console.log(e);
            }
        },
        async checkOrder() {
            const { data } = await this.REQUEST({
                url: `v2/order/payment/check?id=${this.orderId}`,
            });
            if (!data.pay_success) {
                this.$data._timer = setTimeout(() => {
                    this.checkOrder();
                }, 3000);
                return;
            }
            this.$emit('success', { orderId: this.orderId });
        },
    },
};
</script>

<style lang="stylus" scoped>
.canvas
    width 200px
    height 200px
</style>
